<template>
  <v-autocomplete
    hide-details="auto"
    :items="expenseCategories"
    :loading="loading"
    v-model="filterDatas.expenseCategory"
    item-text="name"
    item-value="id"
    label="Expense Category"
    clearable
    outlined
    dense
    @change="emitInput(filterDatas.expenseCategory)"
    :search-input.sync="searchCategory"
  ></v-autocomplete>
</template>
<script>
import { mapState } from 'vuex';

export default {
  props: {
    clear: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    expenseCategories: [],
    selectedExpenseCategory: null,
    searchCategory: null,
    loading: false,
  }),
  computed: {
    ...mapState(['filterDatas']),
  },
  methods: {
    emitInput(data) {
      this.$store.commit('UPDATE_EXPENSE_CATEGORY_FILTER', data);

      this.$emit('input', this.filterDatas.expenseCategory);
    },
    getExpenseCategoryByQuery(query = '') {
      this.loading = true;
      this.$store
        .dispatch('sitesetting/GetExpenseCategories', {
          query: this.filterDatas.expnseCategoryquery
            ? this.filterDatas.expnseCategoryquery
            : query,
        })
        .then((res) => {
          this.loading = false;
          this.expenseCategories = res.data.data;
        })
        .catch((err) => {
          this.loading = false;
        });
    },
  },
  watch: {
    clear: {
      handler(val) {
        this.selectedSupplier = null;
      },
      deep: true,
    },
    searchCategory: {
      handler(val) {
        this.$store.commit('UPDATE_EXPENSE_CATEGORY_QUERY_FILTER', val);
        this.getExpenseCategoryByQuery(val);
      },
      deep: true,
    },
  },
  created() {
    this.$emit('input', this.filterDatas.expenseCategory);
    this.getExpenseCategoryByQuery();
  },
};
</script>
